import { navigateWithReload } from '../../../../../src/app/shared/utils/navigate-force-reload';
import { getFlagClass } from "../../../../../src/app/shared/utils/flag-class";

class SettingsPhoneList {
    [x: string]: any;
 	 static $inject = ['$state','$translate','$stateParams','$anchorScroll', '$location', 'Router'];
    constructor($state, $translate, $stateParams, $anchorScroll, $location, Router) {
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.anchorScroll = $anchorScroll;
        this.$location = $location;
        this.router = Router;
    }

    responsiveMenuShow(){
        if (this.numbers.length > 1) this.showMenu = !this.showMenu;
    }

    setCurrentNumber(number){
        this.currentNumber = number ? number : this.numbers[0];
    }

    getFlagClass(number){
      return getFlagClass(number);
    }

    goToNumberSettings(number) {
      const url = this.getNumberSettingsUrl(number);
      // dirty hack to force reload on the settings only when clicking on list items
      navigateWithReload(this.router, url);
    }

    getNumberSettingsUrl(number) {
      const urlType = number.inbound ? 'settings' : 'custom';
      return `phone-numbers/${number.id}/${urlType}`;
    };

    hasNumbers() {
        return this.numbers && this.numbers.length > 0;
    }

    findNumberToDisplay(id) {
        return id ? this.getCurrentNumber(id) : this.getLastNumber();
    }

    getLastNumber() {
        return this.numbers[this.numbers.length - 1];

    }

    getCurrentNumber(id) {
        return this.numbers.find(n => n.id === id);
    }

    getMsisdnInfo(msisdn) {
        if (msisdn) {
          return msisdn;
        }
      const { selectedNumber } = this.$stateParams;
      return selectedNumber ? selectedNumber : this.$translate.instant('PENDING') + '...';
    }

    onChangeFind(find) {
      this.find = find;
    }
}

export default {
    controller: SettingsPhoneList,
    template : require('./settings.phone.list.html'),
    bindings: {numbers: '<'}
};
